import { SortableDndContainer } from '@containers/common/sortable-dnd-container/sortable-dnd-container';
import {
    DragEndEvent,
    UniqueIdentifier
} from '@dnd-kit/core';
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { SelectOption } from "@idw-types/common";
import { CSSProperties, useMemo } from 'react';
import styles from "./sortable-languages-container.less";
import { SortableDndItem } from '@containers/common/sortable-dnd-container/sortable-dnd-item/sortable-dnd-item';

type SortableLanguagesContainerProps = {
    isDisabled: boolean;
    selectedLanguages: Array<SelectOption<LocaleTypes>>;
    updateLanguagesPositions: (availableLanguages: Array<SelectOption<LocaleTypes>>) => void;
}
export const SortableLanguagesContainer = ({ isDisabled, selectedLanguages, updateLanguagesPositions }: SortableLanguagesContainerProps) => {
    const languageValues = useMemo(() => selectedLanguages.map(lng => lng.value as UniqueIdentifier), [selectedLanguages]);
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            const oldIndex = languageValues.indexOf(active.id);
            const newIndex = languageValues.indexOf(over.id);
            const updatedLanguages = Array.from(selectedLanguages);
            const [removed] = updatedLanguages.splice(oldIndex, 1);
            updatedLanguages.splice(newIndex, 0, removed);
            updateLanguagesPositions(updatedLanguages);
        }
    }

    const languageItemStyle: CSSProperties = {
        padding: "0.5rem 1rem",
        display: "flex",
        alignItems: "center",
        border: "1px solid #dee2e6",
        marginBottom: "0.5rem"
    }

    const languageElements: Array<(shouldApplyPlaceholder: boolean) => React.ReactNode> = useMemo(() => {
        return selectedLanguages.map(language => (
            () => (
                <SortableDndItem
                    key={language.value}
                    isActiveId={null}
                    showDragAndDropIcon={true}
                    id={language.value}
                    activeIdStyle={{}}
                    additionalStyle={languageItemStyle}
                >
                    <>{language.label}</>
                </SortableDndItem>
            )));
    }, [selectedLanguages]);

    return (
        <div className={styles.sortableLanguagesContainer}>
            <SortableDndContainer
                isDisabled={isDisabled}
                internalDragAndDropElements={languageElements}
                internalDragAndDropElementsValues={languageValues}
                handleDragEnd={handleDragEnd}
                activeId={null}
                setActiveId={() => { }}
            />
        </div>
    );
}